import { useEffect } from 'react';

const useTitle = (title: string) => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_SITE_TITLE} | ${title}`;
  }, [title]);
};

export default useTitle;
